module.exports = {"610827001":"银州街道","610827101":"桃镇","610827102":"龙镇","610827103":"杨家沟镇","610827104":"杜家石沟镇","610827105":"沙家店镇","610827106":"印斗镇","610827107":"郭兴庄镇","610827108":"城郊镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610827.json
// module id = 2867
// module chunks = 0